import { useQuery } from "@tanstack/react-query";
import { getAreas } from "../actions/getAreas";

export const useAreasQuery = ({ categoryUid = null, squareFt = null, typeOfServiceUid = null }) => {
  const areasQuery = useQuery({
    queryKey: ["areas", categoryUid, squareFt, typeOfServiceUid],
    queryFn: () => getAreas({ categoryUid, squareFt, typeOfServiceUid }),
    // staleTime: 1000 * 60 * 60
    staleTime: 0,
  });

  return areasQuery;
};
